import React, { Component } from 'react';
import _ from 'underscore';

class MobileNumberPad extends Component {
    constructor(props) {
        super(props);

        this.state = {
            number:[]
        };

    }

    dismiss() {
        this.props.unmountMe();
    }
    componentDidMount() {
        if (this.props.autoFocus)
            this.refs.input0.focus();

        document.addEventListener('keydown', this.handleKeyPress);

    }
    onKeyDown(index, e) {
        if (e.keyCode === 8) {
            e.preventDefault();
            let currentElement = this.refs[`input${index}`];
            let previousElement = this.refs[`input${index - 1}`];
            if (currentElement)
                currentElement.value = '';
            if (previousElement)
                previousElement.focus();

        }
    }


    onChange(index, eventArgs) {


        this.state.number[index] = eventArgs.target.value;

        if (index < (this.props.strength - 1)) {
            let nextRef = `input${index + 1}`;
            let nextElement = this.refs[nextRef];
            nextElement.focus();
        } else if (index === (this.props.strength - 1)) {
            let number = `04${this.state.number.join('')}`;
            this.props.mobileNumberComplete(number);
        }

    }

    componentDidUpdate(prevProps) {

        if (!prevProps.enabled && this.props.enabled && this.props.autoFocus)
            this.refs.input0.focus();
    }

    render() {

        return (
            <div>
                <span className="m-r-5"></span>

                <input
                    className="form-control input-single"
                    type="tel"
                    maxLength="1"
                    disabled={true} value='0' />
                <input
                    className="form-control input-single"
                    type="tel"
                    maxLength="1"
                    disabled={true} value='4' />
                {


                    _(this.props.strength).times(function (n) {
                        let refName = `input${n}`;

                        return (
                            <input
                                className="form-control input-single"
                                key={refName}
                                type="tel"
                                ref={refName}
                                maxLength="1"
                                onChange={this.onChange.bind(this, n)}
                                onKeyDown={this.onKeyDown.bind(this, n)}
                                disabled={!this.props.enabled} />
                        );
                    }.bind(this))
                }
            </div>);

    }
}
export default MobileNumberPad;


// WEBPACK FOOTER //
// ./app/util/mobileNumberPad.js